import React, { useState } from 'react';
import './index.css';
import '../App.css';
import { Dropdown } from 'react-bootstrap';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { TextInput } from './index';

const CustomToggle = React.forwardRef(({ isToggled, label, value, width, onClick, onChange }, ref) => {
    const iconClass = isToggled ? "IconClassActive" : "IconClass";
    return (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
        }}>
            <div className="divRow" style={{ alignItems: "center" }}>
                <TextInput
                    id="message"
                    inputProps={{ autoComplete: "off" }}
                    label={label}
                    value={value}
                    style={{ width: width }}
                    onChange={onChange} />
                <SearchOutlinedIcon className={iconClass} />
            </div>
        </div>
    );
});

const CustomToggleDisabled = ({ width, label }) => {
    return (
        <div 
            className="inputValue divRow inputValueDisabled"
            aria-disabled="true"
            style={{ alignItems: 'center', justifyContent: 'space-between', width: width }}>
            <label className="label14" style={styles.formLabel}>{label}</label>
            <SearchOutlinedIcon className="IconClass" />
        </div>
    );
}

const DropdownItem = ({ item }) => {
    return (
        <Dropdown.Item eventKey={item.studentId} className="dropdown-eachitem">
            <div className="Dropdown-studentId">{item.studentId}</div>
            <div className="Dropdown-studentName">{item.firstName} {item.lastName}</div>
        </Dropdown.Item>
    );
}

export const SearchDropdown = ({ disabled=false, label="", value="", items=[], width=200, onChange=null, onSelect=null }) => {
    // Fix: Move useState before any conditional returns
    const [isToggled, setIsToggled] = useState(false);
    
    if (disabled) {
        return <CustomToggleDisabled width={width} label={label} />
    }
    
    return (
        <Dropdown onToggle={e => setIsToggled(e)} onSelect={(e) => onSelect(e)}>
            <Dropdown.Toggle
                as={CustomToggle}
                isToggled={isToggled}
                label={label}
                value={value}
                width={width}
                onChange={onChange}
                id="dropdown-custom-components" />
            <Dropdown.Menu 
                className="dropdownConfig" 
                style={{ width: width, opacity: items.length ? 1 : 0 }}
                align="start"
            >
                {items.map(item => (
                    <DropdownItem key={item.studentId} item={item} />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

const styles = {
    formLabel: {
        color: '#6d758e',
        padding: 0,
        marginLeft: 16
    },
};